module.exports = __webpack_public_path__ + "static/img/case_banner_05.912f7b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_banner_05.png
// module id = zDua
// module chunks = 34